import { useMemo, useRef } from "react";
import { ScreenshotterItem } from "../types/screenshotter.types";
import { apiUrl } from "src/constants/config";

export interface AdPreviewStudioProps {
  targetUrl: string;
  item: ScreenshotterItem;
}


export default function AdPreviewStudio({ targetUrl: targetUrl, item: item }: AdPreviewStudioProps) {
//   const [targetUrl, setTargetUrl] = useState(initialTargetUrl);
//   const [assetUrl, setAssetUrl] = useState(initialItem.asset_url);
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  const src = useMemo(() => {
    if (!targetUrl || !item.asset_url) return "";
    return `${apiUrl}/b2b/screenshotter/${item.id}?target=${encodeURIComponent(targetUrl)}&mode=iframe`;
    // return `/preview/select?url=${encodeURIComponent(targetUrl)}&asset=${encodeURIComponent(item.asset_url)}&fit=contain`;
  }, [targetUrl, item.asset_url]);

  const sendAssetToChild = () => {
    const w = iframeRef.current?.contentWindow;
    if (!w) return;
    // The injected script listens for this and updates ASSET.url live
    w.postMessage({ __apv: true, type: "set-asset", asset_url: item.asset_url }, "*");
  };

  return (
    <div style={{ height: "100vh" }}>
      {/* <form
        onSubmit={(e) => { e.preventDefault();}}
        style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}
      >
        <input
          type="url" value={targetUrl} onChange={(e)=>setTargetUrl(e.target.value)}
          placeholder="https://publisher.com/page" style={{ minWidth: 380, flex: 1, padding: 8 }}
        />
        <input
          type="url" value={assetUrl} onChange={(e)=>setAssetUrl(e.target.value)}
          placeholder="https://cdn/creative.png" style={{ minWidth: 320, flex: 1, padding: 8 }}
        />
        <button
          type="button"
          onClick={sendAssetToChild}
        >
          Update Asset
        </button>
      </form> */}

      <iframe
        ref={iframeRef}
        src={src || "about:blank"}
        title="Ad Preview"
        sandbox="allow-scripts allow-same-origin"
        style={{ width: "100%", height: "100%", border: 0, background: "white" }}
      />
    </div>
  );
}
